module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/playerHeadshots/nfl/survive-49b6d3b780cc2da3c2e01da79056e38e.svg";